module.exports = __webpack_public_path__ + "static/media/Significant-role.bbb689fb.svg";